// removed by extract-text-webpack-plugin
module.exports = {"ui":"_3eCsGd1nF9rGlKWTqjtm9m","inverted":"_1NMsHyUlvGf4VnR0ByTF5X"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/components/site.min.css
// module id = 1799
// module chunks = 0